export { BlogTable } from './table';
